import req from './http.js'

// 取得店家列表
export const apiGetMerchantById = params => req('post', '/reservation/adminManage/getMerchantById', params)

// 用id取得store name
export const apiGetStoreById = params => req('post', '/reservation/adminManage/getStoreById', params)

// 查詢課程
export const apiGetTicketProjectList = params => req('post','/reservation/adminManage/getTicketProjectList', params)

